export const PLANS = {
    ANNUAL_INDIVIDUAL: 'annual-individual',
    ANNUAL_ENTERPRISE: 'annual-enterprise',
    ANNUAL_FREE_TRIAL: 'annual-free-trial',
    SEMI_ANNUAL_INDIVIDUAL: 'semi-annual-individual',
    SEMI_ANNUAL_FREE_TRIAL: 'semi-annual-free-trial'
};
export const isSmallOrFreePlan = (planName) => {
    return (planName === null || planName === void 0 ? void 0 : planName.includes('individual')) || (planName === null || planName === void 0 ? void 0 : planName.includes('free'));
};
